import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        
        {/* Left Section: Email */}
        <div className="footer-email">
          {/* Simple SVG Mail Icon */}
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
          <a href="mailto:info@digitoe.ai" style={{color: 'inherit', textDecoration: 'none'}}>
            info@digitoe.ai
          </a>
        </div>

        {/* Right Section: Navigation Links */}
        <div className="footer-links-section">
          <div className="footer-column">
            <h4>Information</h4>
            <ul>
              <li><a href="#home">Home</a></li>
              <li><a href="#about">About us</a></li>
              <li><a href="#contact">Contact us</a></li>
            </ul>
          </div>
          
          <div className="footer-column">
            <h4>Our Solutions</h4>
            <ul>
              <li><a href="#products">Products</a></li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar: Copyright & Legal */}
      <div className="footer-bottom-bar">
        <div>@2024 Digitoe Ltd.</div>
        
        <div className="footer-bottom-links">
          <a href="#terms">Terms & Conditions</a>
          <a href="#privacy">Privacy Policy</a>
        </div>

        <div className="footer-socials">
           {/* LinkedIn Icon */}
           <a href="https://www.linkedin.com/company/digitoe" target="_blank" rel="noopener noreferrer">
             in
             {/* Alternatively, you can use an SVG or FontAwesome icon here */}
           </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
